var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoonStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.32373 9.99988C5.42286 9.99988 9.55652 5.86622 9.55652 0.76709C9.55652 5.86622 13.6902 9.99988 18.7893 9.99988C13.6902 9.99988 9.55652 14.1335 9.55652 19.2327C9.55652 14.1335 5.42286 9.99988 0.32373 9.99988Z",
    fill: "#FCDEB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9023 4.65393C17.049 4.65393 18.7892 2.91373 18.7892 0.76709C18.7892 2.91373 20.5294 4.65393 22.676 4.65393C20.5294 4.65393 18.7892 6.39413 18.7892 8.54077C18.7892 6.39413 17.049 4.65393 14.9023 4.65393Z",
    fill: "#FCDEB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9023 15.3458C17.049 15.3458 18.7892 13.6056 18.7892 11.459C18.7892 13.6056 20.5294 15.3458 22.676 15.3458C20.5294 15.3458 18.7892 17.086 18.7892 19.2327C18.7892 17.086 17.049 15.3458 14.9023 15.3458Z",
    fill: "#FCDEB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoonStar);
export default __webpack_public_path__ + "static/media/coming-soon-star.ac1890a87d1f1006ecf3f396025e2019.svg";
export { ForwardRef as ReactComponent };